import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MemberLayout } from "@/components/Layout";
import { MapPin } from "lucide-react";

export default function History() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/registrations/mine").then(r => setItems(r.data)); }, []);

  return (
    <MemberLayout title="Min historik">
      {!items && <div className="text-slate-400 text-sm">Laddar…</div>}
      {items && items.length === 0 && <div className="text-slate-500 text-sm text-center py-10">Du har inga registreringar än.</div>}
      {items && items.length > 0 && (
        <div className="space-y-3" data-testid="history-list">
          {items.map(it => (
            <div key={it.id} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between" data-testid={`hist-${it.id}`}>
              <div>
                <div className="text-xs text-slate-500">{new Date(it.activity_date).toLocaleDateString("sv-SE", { day: "numeric", month: "short", year: "numeric" })}</div>
                <div className="flex items-center gap-1.5 text-slate-900 font-semibold mt-0.5"><MapPin size={14}/>{it.location_name}</div>
                <div className="text-sm text-slate-600">{it.activity_type_name}</div>
              </div>
              <div className="text-right">
                <div className="font-heading text-2xl font-extrabold text-slate-900 number-tabular">{it.conversation_count}</div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500">samtal</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </MemberLayout>
  );
}
